export default __webpack_public_path__ + "static/media/back.dca8f875.svg";